export default "__VITE_ASSET__Dkq89C$F__"